import styled from 'styled-components';
import * as colors from '../../../../../../components/common/colorConstants';

export const ResultsHeaderRow = styled.div`
  padding: 8px 0 8px 58px;
  line-height: 1.42857143;
  vertical-align: top;
  color: ${colors.darkGray9};
  display: flex;
`;

export const ResultsHeaderColumn = styled.div`
  font-family: lato, sans-serif;
  line-height: 1.8rem;
  font-size: 9px;
  display: inline-flex;
  align-items: center;
  padding-right: 10px;
  width: ${(props) => props.width || 'auto'};
`;

export const ResultsTable = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 300px;
`;
